import { z } from "zod";

export const APP_BRANDING_STORAGE_KEY = "needl-app-branding";

export const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

const hexColor = z.string().regex(HEX_COLOR_REGEX, "Must be a #RRGGBB colour");
const assetUrl = z.string().min(1);
const brandText = z.string().trim().min(1).max(255);

/** A profile resolved for rendering: the server config flattened, with the
    signed URLs it already carries. */
export const appBrandSchema = z.object({
  id: z.string(),
  name: brandText,
  appName: brandText,
  tabTitle: brandText,
  primary: hexColor,
  gradient: z
    .object({ from: hexColor, via: hexColor, to: hexColor })
    .optional(),
  logo: assetUrl,
  favicon: assetUrl,
});

export type AppBrand = z.infer<typeof appBrandSchema>;

/** Only which profile is applied — that is per-browser. The brand itself is
    resolved from the list, never stored: the row is shared, and stored signed
    URLs would outlive their expiry. */
export const appBrandSelectionSchema = z.object({
  activeId: z.string().min(1),
});
